<div class="generalPage">
  <div class="help-content-container  print-content print-all-content">
    <h1 class="top-heading content-blue" role="heading" aria-level="2">{{stt_Acronym_header}}</h1>
    <div class="answerHome font-16 content-blue width-100">{{stt_Acronym_subtitle_description}}</div>

    <div class="Acronym-table answerHome font-16  content-blue width-100">
      <ul class="Acronym-table-ul  font-16">
        <li class="Acronym-row width-70" *ngFor="let subheader of stt_Acronym_Table_header;let i = index" [ngClass]="{'width-20' : i==0}" tabindex="0">
        <strong>{{subheader}}</strong></li>
      </ul>

    </div>
    <div class="Acronym-table answerHome font-16 content-blue width-100 mb-2">
      <ul class="Acronym-table-ul" *ngFor="let st of stt_acronymsdisplay">
        <li class="width-20 Acronym-row vertical-align-top">{{st.key}}</li>
        <li class="width-70 Acronym-row">{{st.value}}</li>
      </ul>
    </div>
  </div>
</div>
